<template>
  <v-app-bar dark app color="primary">
    <v-btn icon class="mr-3" @click.prevent="setDrawer(!drawer)">
      <v-icon> {{ !!drawer ? 'mdi-dots-vertical' : 'mdi-format-list-bulleted' }} </v-icon>
    </v-btn>

    <v-toolbar-title> {{ titulo }} </v-toolbar-title>

    <v-spacer />

    <v-btn v-if="permiteVoltar" icon class="mr-3" @click.prevent="goBack()">
      <v-icon> mdi-close </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import store from '@/store'

export default {
  props: {
    titulo: {
      type: String,
      default: ''
    },
    permiteVoltar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    drawer() {
      return store.getters.getDrawer
    }
  },
  methods: {
    setDrawer(value) {
      store.commit('setDrawer', value)
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>
